import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
export function Support() {
  return <footer className="px-4 pb-28 pt-6 text-center" data-id="element-214" data-mp="1crwqtzhtes5d">
      <div className="mx-auto flex max-w-xs flex-col items-center rounded-2xl border border-white/10 bg-hockey-card p-5" data-id="element-215" data-mp="1cpakg36nuioq">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-hockey-pink/15" data-id="element-216" data-mp="12t75txumgrkw">
          <SettingsIcon className="h-6 w-6 text-hockey-pink" data-id="element-217" data-mp="p1spjys3n4hj" />
        </div>
        <p className="mt-3 text-sm font-bold text-white" data-id="element-218" data-mp="ozppsn159wzm">¿Necesitas ayuda? Soporte</p>
        <a href="mailto:EbookDreamShop@gmail.com" className="mt-1 inline-flex items-center gap-1.5 text-sm text-hockey-pink" data-id="element-219" data-mp="tttwr6aeu50p">
          <MailIcon className="h-4 w-4" data-id="element-220" data-mp="k2681d58n22x" /> EbookDreamShop@gmail.com
        </a>
      </div>
      <p className="mt-6 text-[11px] text-white/30" data-id="element-221" data-mp="636je5hq6n6r">
        © {new Date().getFullYear()} Hockey Pro System · Producto digital · Pago único
      </p>
    </footer>;
}